// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-uploader.img[data-v-1720bff7]{height:200px}.avatar-uploader.img[data-v-1720bff7] .el-upload{height:inherit}.image[data-v-1720bff7]{max-width:100%;max-height:100%}", ""]);
// Exports
module.exports = exports;
